import React, { useMemo, useState } from "react";
import { Card, Spin, Empty, Pagination } from "antd";
import "../../styles/components/pvCardList/pvCardList.scss";

const PvCardList = ({
  data = [],
  columns = [],
  onRowClick,
  reverse = true,
  loading = false,
  style,
  maxActiveRow = 10, // same default as your Table
  showSizeChanger = false, // set true if you want user to change page size
  onPageChange, // optional callback (page, pageSize)
  showPagination = true,
}) => {
  console.log(data);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(maxActiveRow);

  const ordered = useMemo(
    () => (reverse ? [...data].reverse() : data),
    [data, reverse]
  );

  const total = ordered.length;
  const start = (page - 1) * pageSize;
  const end = start + pageSize;
  const pageItems = ordered.slice(start, end);

  const handleChange = (p, ps) => {
    setPage(p);
    if (ps !== pageSize) {
      setPageSize(ps);
      // keep user on a valid page after size change
      const maxPage = Math.max(1, Math.ceil(total / ps));
      if (p > maxPage) setPage(maxPage);
    }
    onPageChange?.(p, ps);
  };

  if (loading) {
    return (
      <div className="pv-cardlist-loading">
        <Spin />
      </div>
    );
  }

  if (!total) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No records found" />;
  }

  return (
    <div className="pv-cardlist-wrapper" style={style}>
      <div className="pv-cardlist">
        {pageItems.map((item, index) => (
          <Card
            key={item.id ?? `${start}-${index}`}
            className="pv-cardlist-item"
            hoverable
            onClick={() => onRowClick && onRowClick(item)}
          >
            {columns.map((col) => (
              <div className="pv-cardlist-row" key={col.key || col.dataIndex}>
                <span className="pv-cardlist-label">{col.title}:</span>
                <span className="pv-cardlist-value">
                  {col.render
                    ? col.render(item[col.dataIndex], item)
                    : item[col.dataIndex]}
                </span>
              </div>
            ))}
          </Card>
        ))}
      </div>
      {showPagination ? (
        <div className="pv-cardlist-pagination">
          <Pagination
            current={page}
            pageSize={pageSize}
            total={total}
            showSizeChanger={showSizeChanger}
            onChange={handleChange}
            onShowSizeChange={handleChange}
            size="small"
          />
        </div>
      ) : null}
    </div>
  );
};

export default PvCardList;
